import * as React from "react";
import * as Dialog from "@radix-ui/react-dialog";
import styles from "./SideWindow.module.scss";
import StyledButton from "../styledButton/StyledButton";

type SideWindowProps = {
  title?: string;
  description?: string;
  children: React.ReactNode;
  isWindowOpen: boolean;
  setIsWindowOpen: (isWindowOpen: boolean) => void;
  onSave?: () => void;
  saveButtonText: string;
};

export function SideWindow({
  title,
  description,
  children,
  isWindowOpen,
  setIsWindowOpen,
  onSave,
  saveButtonText,
}: SideWindowProps) {
  const SideWindowActions = () => (
    <div className={styles.sideWindowActions}>
      <StyledButton
        baseClassname={styles.closeButton}
        onClick={() => setIsWindowOpen(false)}
        text="Close"
      />
      {onSave && (
        <StyledButton
          baseClassname={styles.saveButton}
          onClick={onSave}
          text={saveButtonText}
        />
      )}
    </div>
  );

  return (
    <Dialog.Root open={isWindowOpen} onOpenChange={setIsWindowOpen}>
      <Dialog.Portal>
        <Dialog.Overlay className={styles.sideWindowOverlay} />
        <Dialog.Content
          className={styles.sideWindowContent}
          onOpenAutoFocus={(e) => {
            e.preventDefault();
          }}
        >
          {title && (
            <Dialog.Title className={styles.sideWindowTitle}>
              {title}
            </Dialog.Title>
          )}
          {description && (
            <Dialog.Description className={styles.sideWindowDescription}>
              {description}
            </Dialog.Description>
          )}
          <div className={styles.sideWindowBody}>{children}</div>
          <SideWindowActions />
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
